// extracted by mini-css-extract-plugin
export var dropdown = "_ka-0";
export var imagePlaceholder = "_ka-2";
export var imageWrapper = "_ka-3";
export var productImage = "_ka-1";
export var truncateContainer = "_ka-4";
export var truncateText = "_ka-5";